import { render, staticRenderFns } from "./RegistrationFull.vue?vue&type=template&id=fd85a56e&"
import script from "./RegistrationFull.vue?vue&type=script&lang=js&"
export * from "./RegistrationFull.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFull.vue?vue&type=style&index=0&id=fd85a56e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports